<div class="info-box">
    <div class="info-box__inner">

        <shared-indicator [size]="size" [icon]="icon" [inverted]="inverted" [feel]="feel" class="info-box__indicator">
        </shared-indicator>

        <div class="info-box__content -left-offset-{{size}}">
            <div class="info-box__col -left">

                <shared-header [postContent]="postContent" [preContent]="preContent" [ellipsis]="ellipsis"
                    [center]="centerHeader" [counter]="counter" [loading]="loading" [type]="type" [left]="left"
                    [right]="right" [marginTop]="marginTop" [paddingTop]="paddingTop" [paddingBottom]="paddingBottom"
                    [brandAccent]="brandAccent" class="info-box__hd">
                    <ng-content></ng-content>
                </shared-header>

                <div class="info-box__bd" *ngIf="description">{{description}}</div>

                <div class="info-box__ft" *ngIf="homeLink">
                    <shared-link [emphasis]="false" (onClick)="handleLinkClick($event)">{{homeLinkTitle}}</shared-link>
                </div>
            </div>

            <div class="info-box__col -right" *ngIf="src">
                <img [src]="src" class="info-box__img" />
            </div>

        </div>


    </div>
</div>
